import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import CustomBoldEditing from './customboldediting';

export default class CustomBold extends Plugin {
    static get requires() {
        return [CustomBoldEditing];
    }

    static get pluginName() {
        return 'CustomBold';
    }
}